<template>
  <div class="bg-white h-[60px] w-full flex justify-between items-center md:hidden p-4">
    <div
      class="size-12 cursor-pointer bg-gray-200 rounded-full text-gray-500 flex items-center justify-center"
      @click="is_menu_open = !is_menu_open"
    >
      <FontAwesomeIcon
        icon="bars"
        size="lg"
      />
    </div>
    <avatar
      :format="current_tenant?.attributes?.picture_logo_format"
      size="40"
      :src="current_tenant?.attributes?.picture_logo_url_s"
      :username="current_tenant?.attributes?.name"
    />
    <TheNotificationsToggleIcon />
  </div>
  <Drawer
    v-model:visible="is_menu_open"
    :pt="{
      content: 'p-0',
    }"
  >
    <TheNavbarDesktopProject @close="is_menu_open = false" />
  </Drawer>
</template>

<script setup>
import { computed, ref } from 'vue';
import TheNavbarDesktopProject from '@/app/_partners/components/navbar/TheNavbarDesktopProject.vue';
import { useStore } from 'vuex';
import TheNotificationsToggleIcon from '@/app/shared_components/navbar/notifications/TheNotificationsToggleIcon.vue';

const store = useStore();
const current_tenant = computed(() => store.getters.current_tenant);
const is_menu_open = ref(false);
</script>
